import { Rating } from '../../../../../components/rating/rating';
import { useLang } from '../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../hooks/use-query-params';
import { useReviewsStore } from '../../../../../store/use-reviews-store';
import s from './reviews-marks.module.css';
import { ReviewsWidget } from './reviews-widget/reviews-widget';

export const ReviewsMarks = () => {
  const { positive, negative, neutral } = useReviewsStore();
  const { t } = useLang();
  const { getQueryParams } = useQueryParams();
  const params = getQueryParams();
  const isWidgetExpanded = params.is_expanded === '1';

  return (
    <div className={s.feature}>
      <ReviewsWidget
        type="negative"
        label={t('Негативные')}
        className={s.negative}
        isExpanded={isWidgetExpanded}
        count={negative?.count}
        rows={negative?.items.map((item) => ({
          rate: <Rating rate={item.rating} readOnly single />,
          text: item.content,
        }))}
      />
      <ReviewsWidget
        type="neutral"
        label={t('Нейтральные')}
        className={s.neutral}
        isExpanded={isWidgetExpanded}
        count={neutral?.count}
        rows={neutral?.items.map((item) => ({
          rate: <Rating rate={item.rating} readOnly single />,
          text: item.content,
        }))}
      />
      <ReviewsWidget
        type="positive"
        label={t('Позитивные')}
        className={s.positive}
        isExpanded={isWidgetExpanded}
        count={positive?.count}
        rows={positive?.items.map((item) => ({
          rate: <Rating rate={item.rating} readOnly single />,
          text: item.content,
        }))}
      />
    </div>
  );
};
